<template>
  <f7-page name="privacypolicy" no-toolbar no-swipeback-tmp>
    <div class="privacypolicy">
      <CommonHeader
        :background="'#FFFFFF'"
        :color="'#242323'"
        :text="privacyPolicyData.policyNavTitle"
        :questionIconUrl="'static/images/common/icon_question.svg'"
        :closeIconUrl="'static/images/common/icon_close.svg'"
        :showBack="isInIndex"
        :showClose="isInIndex"
        :showFAQ="isInIndex"
        :showBorder="true"
      />
      <div v-for="(section, index) in sections" :key="index" class="block items">
        <div class="text" v-html="section" @click="handleLinkClick"></div>
      </div>
    </div>
  </f7-page>
</template>

<script setup lang="ts">
import CommonHeader from '@/components/CommonHeader.vue'
import privacyPolicyData from '@/i18n/messages/ja/privacyPolicy.json'
import { openWebview } from '@/utils/pp'

const isInIndex = !new URL(window.location.href).searchParams.get('to')
const sections = privacyPolicyData.sections as string[]

const handleLinkClick = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  if (target.tagName === 'A') {
    event.preventDefault()
    const url = target.getAttribute('href')
    if (url) {
      openWebview({
        style: 'modal',
        url,
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/css/mixins.scss';

#updated {
  width: 100%;
  text-align: right;
}

.privacypolicy {
  background: #f2f2f2;
  padding-left: 0px;
  padding-right: 0px;
}

.block {
  background: #fff;
  margin: 0px;
  padding: 0px 0px;
}

.page-content {
  .block,
  .block p {
    margin: 0px;
    padding: 0px;
  }

  .block {
    &.items {
      padding: 20px 20px;

      .title {
        padding-bottom: 20px;
        color: #242323;
        font-size: 14px;
        font-weight: 400;
        line-height: 19px;
      }

      .text {
        color: #242323;
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;

        :deep(h2) {
          text-align: center;
        }

        :deep(h3) {
          margin: 0;
        }

        :deep(note) {
          display: block;
          color: #909090;
          padding: 20px 0;
        }
        :deep(ul) {
          margin: 0;
        }
        :deep(a) {
          color: #0066cc;
          text-decoration: none;
        }
        :deep(a:hover) {
          color: #0052a3;
        }
        :deep(p.policy-date) {
          text-align: right;
        }
      }
    }
  }
}
</style>
